import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-input-formly',
  templateUrl: './input.component.html'
})
export class InputTypeComponent extends FieldType {
}
